<template lang="">
  <router-view></router-view>
</template>

<script>
export default {

  name: 'ConfirmacionProcesos',
  data () {
    return {
    }
  }
  
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/confirmacion-procesos.vue